import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import CustomButton from "../../../helperComponents/CustomButton";
import { MdDelete } from "react-icons/md";
import { PiPlus } from "react-icons/pi";
import DropDownInput from "../../../helperComponents/DropDownInput";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* background: var(--surface3); */
  /* border: 1px solid var(--borderDim); */
  /* padding: 10px; */
  border-radius: 10px;
  gap: 30px;
  width: 100%;
  /* padding: 10px 15px; */
`;

const TopPart = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.div`
  font-size: 17px;
  /* opacity: 0.5; */
  color: var(--elementDim);
  text-transform: capitalize;
`;

const ContractName = styled.div`
  font-size: 17px;
  /* opacity: 0.5; */
  color: var(--elementDim);
  text-transform: capitalize;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  position: relative;
`;

const SubRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 62%;
  gap: 15px;
`;

const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default function AssistanceInputForSite({
  value,
  onChange,
  label,
  options,
}) {
  if (!value) value = [];

  return (
    <Container>
      <TopPart>
        {/* <Label>{label}</Label> */}

        <DropDownInput label={label} options={options} onChange={addNew} />
      </TopPart>

      <List>
        {value.map((item, index) => {
          return (
            <ItemColumn>
              <ContractName>{getContractName(item.type)}</ContractName>
              <Row>
                <SubRow>
                  <MaterialInput
                    type="number"
                    label="Compter"
                    value={item.count}
                    onChange={updateValue({ field: "count", index })}
                  />
                </SubRow>
                <CustomButton
                  style={{
                    width: "55px",
                    height: "55px",

                    borderRadius: "10px",
                  }}
                  onClick={removeRow(index)}
                  icon={<MdDelete />}
                ></CustomButton>
              </Row>
            </ItemColumn>
          );
        })}
      </List>
    </Container>
  );

  function getContractName(type) {
    for (let item of options) {
      if (item.value == type) return item.label;
    }

    return "Aucun";
  }

  function addNew(newType) {
    let newValue = [...value];
    newValue.push({ type: newType, count: 0 });
    onChange(newValue);
  }

  function removeRow(index) {
    return () => {
      // if (value.length <= 1) return null;

      let newValue = [...value];

      newValue.splice(index, 1);

      onChange(newValue);
    };
  }

  function updateValue({ field, index }) {
    return (e) => {
      let newValue = [...value];

      newValue[index][field] = e.target.value;

      onChange(newValue);
    };
  }
}
